import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { publicSvgPath } from '@orientaction/utils';

export default makeStyles((theme: Theme) => ({
  grayBG: {
    background: '#EDEEF2 0% 0% no-repeat padding-box',
  },
  noPadding: {
    '&>div': {
      '@media(min-width: 1250px)': {
        padding: '0px !important',
      },
    },
  },
  imageBG: {
    position: 'relative',
    backgroundColor: 'transparent',
    '&::before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 0,
      pointerEvents: 'none',
      backgroundImage: `url(${publicSvgPath}/backgroundBtn/pattern.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'center',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
    '@supports (height: 100dvh)': {
      '&::before': {
        height: '100dvh',
        width: '100dvw',
      },
    },
    '@media only screen and (max-width: 600px)': {
      '&::before': {
        backgroundImage: `url(${publicSvgPath}/backgroundBtn/pattern_mobile.png)`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
      },
    },
    '@supports (-webkit-touch-callout: none)': {
      backgroundColor: '#0E1444',
      '&::before': {
        top: 0,
        bottom: 0,
        height: '100lvh',
      },
    },
    '@media only screen and (max-width: 361px)': {
      '&::before': {
        backgroundImage: 'none',
      },
    },
  },
  imageBG2: {
    position: 'relative',
    backgroundColor: 'transparent',
    '&::before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 0,
      pointerEvents: 'none',
      backgroundImage: `url(${publicSvgPath}/backgroundBtn/pattern2.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      backgroundPosition: 'center',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
    '@supports (height: 100dvh)': {
      '&::before': {
        height: '100dvh',
        width: '100dvw',
      },
    },
    '@media only screen and (max-width: 600px)': {
      '&::before': {
        backgroundImage: `url(${publicSvgPath}/backgroundBtn/pattern_mobile.png)`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
      },
    },
    '@media only screen and (max-width: 361px)': {
      '&::before': {
        backgroundImage: 'none',
      },
    },
  },
  imageBG3: {
    background: `url(${publicSvgPath}/fond_homepage.png), #0E1444`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    backgroundPosition: '0% 0%',
    '@media only screen and (max-width: 600px)': {
      background: `url(${publicSvgPath}/fond_transparent_mobile_accueil.png), #0E1444`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% auto',
      backgroundPosition: '0% 0%',
    },
    '@media only screen and (max-width: 361px)': {
      background: `url(${publicSvgPath}/fond_transparent_mobile_accueil.png), #0E1444`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% auto',
      backgroundPosition: '0% 0%',
    },
  },
  bgV2: {
    position: 'relative',
    backgroundColor: '#F7F7FB',
    width: '100% !important',
    maxWidth: '100% !important',
    minHeight: '100vh',
    overflowX: 'hidden' as any,
    '&::before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 0,
      pointerEvents: 'none',
      backgroundImage: 'url(/images/Background/background_test_v2.svg)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
    '@supports (height: 100dvh)': {
      '&::before': {
        height: '100dvh',
        width: '100dvw',
      },
    },
    '@media only screen and (max-width: 600px)': {
      backgroundColor: '#fff',
      '&::before': {
        backgroundImage: 'none',
      },
    },
  },
  imageClassic: {
    background: '#0E1444',
  },
  layout: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    width: '100%',
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    '&>div': {
      color: theme.palette.primary.main,
      overflow: 'auto',
    },
  },
  appBar: {
    zIndex: theme.zIndex.appBar,
    paddingRight: theme.spacing(3),
    color: theme.palette.primary.main,
    backgroundColor: '#fff',
    border: '1px solid #E3E8F0',
    '&>button': {
      marginRight: theme.spacing(-2),
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(0),
      height: '60px',
    },
  },
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& a': {
      marginRight: theme.spacing(4.75),
    },
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      width: '98.5%',
      margin: '20 auto',
    },
    '@media(min-width: 1250px)': {
      height: 'auto',
    },
  },
  logoContainer: {
    cursor: 'pointer',
    maxWidth: 200,
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 160,
      marginTop: 5,
      marginLeft: 10,
    },
  },
  logo: {
    width: '100%',
    height: 'auto',
  },
  logoImg: {
    width: '100%',
    height: 'auto',
  },
  profilContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > div, hr': {
      '@media(min-width: 1250px)': {
        marginLeft: 25,
        marginTop: 3,
      },
      '@media only screen and (max-width: 600px)': {
        transform: 'translate3d(0px, 41px, 0px) !important',
        width: '100%',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'translate3d(0px, 41px, 0px) !important',
        width: '100%',
      },
    },
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  burgerMenu: {
    '& div, hr': {
      marginLeft: '0px !important',
      '@media(min-width: 1250px)': {
        marginLeft: '0px !important',
      },
    },
  },
  btnPrimary: {
    minHeight: 38,
    height: 38,
    width: 38,
    minWidth: 38,
    textTransform: 'none',
    background:
      'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    '@media(min-width: 600px)': {
      minHeight: 48,
      height: 48,
      width: 146,
      minWidth: 146,
    },
  },
  initial: {
    width: 38,
    height: 38,
    background: '#000A8C 0% 0% no-repeat padding-box',
    borderRadius: '100%',
    color: '#fff',
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      height: '51%',
    },
  },
  divider: {
    display: 'none',
    '@media(min-width: 1250px)': {
      display: 'block',
      height: '20px',
      marginTop: 'auto',
      marginBottom: 'auto',
    },
  },
  textHeader: {
    display: 'none',
    '@media(min-width: 600px)': {
      display: 'block',
    },
  },
  profile: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 !important',
    cursor: 'pointer',
    '& > span': {
      marginLeft: 10,
      '@media(min-width: 1250px)': {
        marginLeft: 30,
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  btnWhite: {
    backgroundColor: '#fff#',
    color: '#0E1247',
    marginTop: 0,
    marginRight: 5,
    borderRadius: 3,
    opacity: 1,
    border: 'solid grey',
    textTransform: 'none',
    minHeight: 48,
    height: 48,
    width: 146,
    minWidth: 146,
    [theme.breakpoints.down('sm')]: {
      padding: '1vh',
      minHeight: 48,
      height: 48,
      width: 140,
      minWidth: 130,
    },
  },
  largeBtnWhite: {
    backgroundColor: '#fff#',
    color: '#0E1247',
    marginTop: 5,
    marginRight: 5,
    borderRadius: 3,
    opacity: 1,
    border: 'solid grey',
    minHeight: 38,
    height: 38,
    width: 38,
    minWidth: 38,
    textTransform: 'none',
    '@media(min-width: 600px)': {
      minHeight: 48,
      height: 48,
      width: 175,
      minWidth: 146,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  children: {
    width: '100%',
    height: 'auto',
    scrollBehavior: 'smooth',
    overflow: 'hidden',
  },
  flagContainer: {
    marginRight: 10,
    paddingBottom: 0,
    marginLeft: '15px !important',
    '@media only screen and (max-width: 600px)': {
      marginTop: -82,
    },
  },
  flagSelectButton: {
    border: '1px solid rgb(202, 202, 202)',
    borderRadius: 6,
    marginRight: 10,
    padding: '5px 7px 5px 10px',
    height: 37,
  },
  btnBoutique: {
    margin: theme.spacing(1),
    fontSize: '0.9rem',
    '& span': {
      textTransform: 'none !important',
      fontFamily: 'ITC Avant Garde Gothic Std Medium !important',
      fontWeight: 400,
    },
    '& .MuiButton-startIcon': {
      width: '20% !important',
    },
    '& .iconOaMatch': {
      width: '70% !important',
    },
  },
  btnOAMatch: {
    margin: theme.spacing(1),
    fontSize: '0.9rem',
    '& span': {
      textTransform: 'none !important',
      fontFamily: 'ITC Avant Garde Gothic Std Medium !important',
      fontWeight: 400,
    },
    '& .MuiButton-startIcon': {
      width: '100% !important',
      '& svg': {
        marginTop: -4,
      },
    },
  },
  basculeButton: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 10,
    paddingBottom: 10,
    marginRight: 30,
    borderRadius: 5,
    overflow: 'hidden',
    border: '1px #000A8C solid',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    display: 'inline-flex',
    textAlign: 'center',
    color: '#000A8C',
    fontSize: 12,
    fontFamily: 'Open Sans',
    fontWeight: 600,
    wordWrap: 'break-word',
    textTransform: 'none',
  },
  logoImg2: {
    width: '40%',
    height: 'auto',
    display: 'block',
    margin: 'auto',
  },
  btnConfirm: {
    width: '100%',
    color: 'white',
  },
  btnCancel: {
    width: '100%',
    border: '1px solid #000A8C',
    color: '#000A8C',
    background: 'white',
  },
  textOADialog: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '140%',
    textAlign: 'center',
    color: '#23296F',
  },
  modal: {
    '& .MuiPaper-root': {
      borderRadius: 16,
    },
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  progressBar: {
    width: '100%',
    margin: 'auto',
  },
  colorPrimary: {
    backgroundColor: '#E3E8F0',
    height: '8px',
    borderRadius: '60px',
  },
  barColorPrimary: {
    background:
      'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    height: '8px',
    borderRadius: '60px',
  },
  btnContacter: {
    padding: 25,
    background: '#e63c3c',
    color: 'white',
    borderRadius: '50px',
    transition: 'all 1s ease',
    fontSize: '12px',
    '&:hover': {
      background:
        'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    },
  },
  btnIcon: {
    border: '1px solid grey',
    borderRadius: '5px !important',
    width: 32,
    height: 32,
    padding: '2px',
    margin: '0 2vh',
  },
  styleIcon: {
    color: '#0E1247',
    width: '20px',
    height: '20px',
  },
  appBarWithProgress: {
    padding: '6px 6px 6px 0 !important',
  },
  progressContainer: {
    '@media (max-width: 1350px)': {
      marginRight: '0 !important',
    },
  },

}));
